export enum ErrorType {
  API_ERROR = 'api_error',
  AUTH_ERROR = 'authentication_error',
  FAILED_RESOURCE_CREATION = 'failed_resource_creation',
  FORBIDDEN = 'forbidden_error',
  INVALID_REQUEST_ERROR = 'invalid_request_error',
  NOT_FOUND = 'not_found',
  NOT_MODIFIED = 'not_modified',
  RANGE_NOT_SATISFIABLE = 'range_not_satisfiable',
  SERVICE_UNAVAILABLE = 'service_unavailable',
  TOO_MANY_REQUESTS = 'too_many_requests',
  UNPROCESSABLE_ENTITY = 'unprocessable_entity',
}

export const STATUS_CODE_MAP: { [type in ErrorType]: number } = {
  [ErrorType.API_ERROR]: 500,
  [ErrorType.AUTH_ERROR]: 401,
  [ErrorType.FAILED_RESOURCE_CREATION]: 409,
  [ErrorType.FORBIDDEN]: 403,
  [ErrorType.INVALID_REQUEST_ERROR]: 400,
  [ErrorType.NOT_FOUND]: 404,
  [ErrorType.NOT_MODIFIED]: 304,
  [ErrorType.RANGE_NOT_SATISFIABLE]: 416,
  [ErrorType.SERVICE_UNAVAILABLE]: 503,
  [ErrorType.TOO_MANY_REQUESTS]: 429,
  [ErrorType.UNPROCESSABLE_ENTITY]: 422,
};
